function generatePassword(length = 12): string {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()';
  const array = new Uint32Array(length);
  window.crypto.getRandomValues(array);

  return Array.from(array, (num) => charset[num % charset.length]).join('');
}
export { generatePassword };
